<template>
  <div>
    <div style="display: block;margin-top: 90px" >
      <img src="../assets/images/benifit2.png"  width="100%"  />
    </div>
    <!--  -->
    <section class="b1">
      <el-row :gutter="0" type="flex" justify= "end">
        <el-col>
          <el-card class="box-card">
            <div class="spanX">
            <div><img src="../assets/images/energia.png" height="40px"/>
              <span>健康能量</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>最聪明的身体清洁器。</p>
              <p>更强壮，我们的健康能源产品是传统能量饮料的科学天然替代品。</p>
            </div>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div class="spanX">
            <div><img src="../assets/images/higado.png" height="40px"/>
              <span>健康肝功能</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>肝脏是人体第二大器官，也是最大的腺体。</p>
              <p>我们的肝脏保健产品经过精心配制，可提供抗氧化剂和其他成分的独特组合，有助于支持长期健康的肝功能。</p>
            </div>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div class="spanX">
            <div><img src="../assets/images/balanza2.png" height="40px"/>
              <span>健康体重</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p> 有效减肥的关键在于对饮食和运动进行积极改变，这已不是秘密。但是，做出这些健康的生活方式改变通常似乎是一项无法克服的任务。</p>
              <p>我们的健康体重管理产品旨在推动健康的饮食习惯，并帮助人们从不健康的食物中彻底休息一下。</p>
            </div>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div class="spanX">
            <div><img src="../assets/images/bone.png" height="40px"/>
              <span>骨骼关节健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>骨头是由生物组织组成的，而矿物质会不断沉积和去除。在健康的成年人中，骨质流失率大约等于骨质流失率。随着年龄的增长，矿物质缺乏会加速骨质流失，最终导致骨质疏松。</p>
              <p>我们的骨骼和关节健康与补品为您提供健康的骨骼和关节的基本成分。</p>
            </div>
            </div>
          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div><img src="../assets/images/mujer1.png" height="40px"/>
              <span>女性健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>尽管男性和女性的总体营养需求非常相似，但年龄可能会出现基于性别的独特健康问题。</p>
              <p>对于40岁以上的女性，可能开始出现与更年期发作有关的症状。我们的女性保健产品旨在支持经期健康，并在过渡到更年期期间帮助改善生活质量。</p>
            </div>

          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col>
          <el-card class="box-card">
            <div><img src="../assets/images/men1.png" height="40px"/>
              <span>男性健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>随着年龄的增长，许多人有患前列腺疾病的风险。</p>
              <p>健康的饮食和运动，再加上专门为前列腺健康配制的补充剂，可以帮助最大程度地降低这种风险。我们的男士保健产品旨在为前列腺健康提供长期支持。</p>
            </div>

          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div><img src="../assets/images/images-1-copia.png" height="40px"/>
              <span>心脏健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>成人平均每天要抽出2,000加仑的血液。作为人体最活跃的器官之一，心脏具有独特的营养需求。营养缺乏症甚至可导致心血管疾病，这是美国第一大死亡原因。</p>
              <p>我们的心脏保健品专门设计用于支持健康的心脏功能。</p>
            </div>

          </el-card>
        </el-col>
        <el-col>
        <el-card class="box-card">
          <div><img src="../assets/images/estomago.png" height="40px"/>
            <span>消化健康</span>
            <br> <br>
            <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
          </div>
          <div class="text item">
            <p>我们的消化保健产品有助于维持健康的消化系统，以实现最佳的营养供应和废物消除。</p>
          </div>

        </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div><img src="../assets/images/inmune1-1.png" height="40px"/>
              <span>免疫健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>免疫系统是人体中最复杂的系统。组织，蛋白质，细胞和器官的不同组合共同支持人体的整体防御。没有适当的营养，免疫系统会变得虚弱和无效。</p>
              <p>我们的免疫保健品有助于支持健康的免疫功能。</p>
            </div>

          </el-card>
        </el-col>
        <el-col>
          <el-card class="box-card">
            <div><img src="../assets/images/vista.png" height="40px"/>
              <span>眼睛健康</span>
              <br> <br>
              <span style="display:block;height: 0px; border:1px solid ;border-color: darkslateblue;  width: 100%"></span>
            </div>
            <div class="text item">
              <p>随着人类年龄的增长，视力自然会下降。随着时间的流逝，视力下降的最重要原因之一是环境因素的破坏。除睡眠期间外，眼睛经常接触环境因素，例如阳光，干燥和空气污染。</p>
              <p>我们的眼睛保健补品旨在支持长期眼睛保健。</p>
            </div>

          </el-card>
        </el-col>
      </el-row>
      <!--
      <el-row>
        <el-col span="12">
          <div class="benifit-content">
            <div><img src="../assets/images/energia.png" height="40px"/>
              <span>健康能量</span>
            </div>
            <p>
              清洁器。最聪明的。更强壮 我们的健康能源产品是传统休克和燃烧能量饮料的科学天然替代品。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/higado.png" height="40px"/>
              <span>健康肝功能</span>
            </div>
            <p>
              肝脏是人体第二大器官，也是最大的腺体。我们的肝脏保健产品经过精心配制，可提供抗氧化剂和其他成分的独特组合，有助于支持长期健康的肝功能。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/balanza2.png" height="40px"/>
              <span>平衡体重</span>
            </div>
            <p>
              有效减肥的关键在于对饮食和运动进行积极改变，这已不是秘密。但是，做出这些健康的生活方式改变通常似乎是一项无法克服的任务。我们的健康体重管理产品旨在推动健康的饮食习惯，并帮助人们从不健康的食物中彻底休息一下。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/bone.png" height="40px"/>
              <span>骨骼和关节健康</span>
            </div>
            <p>
              容易忘记骨头是由生物组织组成的，而矿物质会不断沉积和去除。在健康的成年人中，骨质流失率大约等于骨质流失率。但是，随着年龄的增长，矿物质缺乏会加速骨质流失，最终导致骨质疏松。我们的骨骼和关节健康与补品为您提供健康的骨骼和关节的基本成分。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/mujer1.png" height="40px"/>
              <span>女性健康</span>
            </div>
            <p>
              对于40岁以上的女性，可能开始出现与更年期发作有关的症状。我们的女性保健产品旨在支持经期健康，并在过渡到更年期期间帮助改善生活质量。
            </p>
          </div>
        </el-col>
        <el-col span="12">
          <img  src="../assets/images/sevice-b1.jpg"/>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="12">
          <img  src="../assets/images/sevice-b1.jpg"/>
        </el-col>
        <el-col span="12">
          <div class="benifit-content left">
            <div><img src="../assets/images/energia.png" height="40px"/>
              <span>健康能量</span>
            </div>
            <p>
              清洁器。最聪明的。更强壮 我们的健康能源产品是传统休克和燃烧能量饮料的科学天然替代品。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/higado.png" height="40px"/>
              <span>健康肝功能</span>
            </div>
            <p>
              肝脏是人体第二大器官，也是最大的腺体。我们的肝脏保健产品经过精心配制，可提供抗氧化剂和其他成分的独特组合，有助于支持长期健康的肝功能。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/balanza2.png" height="40px"/>
              <span>平衡体重</span>
            </div>
            <p>
              有效减肥的关键在于对饮食和运动进行积极改变，这已不是秘密。但是，做出这些健康的生活方式改变通常似乎是一项无法克服的任务。我们的健康体重管理产品旨在推动健康的饮食习惯，并帮助人们从不健康的食物中彻底休息一下。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/bone.png" height="40px"/>
              <span>骨骼和关节健康</span>
            </div>
            <p>
              容易忘记骨头是由生物组织组成的，而矿物质会不断沉积和去除。在健康的成年人中，骨质流失率大约等于骨质流失率。但是，随着年龄的增长，矿物质缺乏会加速骨质流失，最终导致骨质疏松。我们的骨骼和关节健康与补品为您提供健康的骨骼和关节的基本成分。
            </p>
          </div>
          <div class="benifit-content">
            <div><img src="../assets/images/mujer1.png" height="40px"/>
              <span>女性健康</span>
            </div>
            <p>
              对于40岁以上的女性，可能开始出现与更年期发作有关的症状。我们的女性保健产品旨在支持经期健康，并在过渡到更年期期间帮助改善生活质量。
            </p>
          </div>
        </el-col>
      </el-row>
      -->
    </section>
  </div>

</template>

<script>
export default {
  name: 'benifit'
}
</script>

<style scoped>
  .text {
    font-size: 16px;
    color: #0086b3;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card{
   width: 80%;
    height: 280px;
   // float: right;
    position: relative;
    margin: auto;
    transition: all .5s;
  }
  .spanX:before{
    clear: both;
  }
  .box-card:hover{
    box-shadow: 0 10px 16px rgba(0, 0, 0, .2);
    border-color: #eee;
    transition: all .2s ease-in-out;
    margin-top: -5px;
    opacity: 0.8;
  }
/*
  .box-card:hover .spanX{
    z-index: auto;
    display: block;
    background: #0077aa;
    opacity: 0.8;
    width: 100%;
    height: calc(280px + 50px);
  // float: right;
    position: relative;
    left: 0px;
    top:0px;
    //margin: auto;
  } */
  .box-card img{
    vertical-align: bottom;
  }
  .box-card span{
    line-height: 40px;
    font-size: 24px;
    font-weight: bold;
  //color: ;
  }
.el-row{
  padding: 50px 3% 25px 3%;
  text-align: left;
}
.el-col{
  justify-content: center;
}
.benifit-content{
  display: block;
  padding-top: 50px;
  }
.benifit-content img{
  vertical-align: bottom;
}
.benifit-content span{
  line-height: 40px;
  font-size: 30px;
  //color: ;
}
  .left{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/benifit.vue